export default __webpack_public_path__ + "static/media/scratch6.4ca87f47.mp3";